import type { Skill } from "../lib/types";

const STRUCT_KEYS: Array<keyof Skill["structuralScores"]> = [
  "discovery",
  "clarity",
  "completeness",
  "structure",
  "effectiveness",
];

export function ScoreRadar({ skill }: { skill: Skill }) {
  const n = STRUCT_KEYS.length;
  const cx = 60;
  const cy = 60;
  const r = 44;
  const points = STRUCT_KEYS.map((key, i) => {
    const angle = (Math.PI * 2 * i) / n - Math.PI / 2;
    const val = skill.structuralScores[key] / 10;
    const x = cx + Math.cos(angle) * r * val;
    const y = cy + Math.sin(angle) * r * val;
    return `${x},${y}`;
  }).join(" ");

  const grid = [0.25, 0.5, 0.75, 1].map((scale) =>
    STRUCT_KEYS.map((_, i) => {
      const angle = (Math.PI * 2 * i) / n - Math.PI / 2;
      const x = cx + Math.cos(angle) * r * scale;
      const y = cy + Math.sin(angle) * r * scale;
      return `${x},${y}`;
    }).join(" ")
  );

  return (
    <svg viewBox="0 0 120 120" className="w-full max-w-[140px] border border-rule" aria-label="Structural dimension radar">
      {grid.map((poly, i) => (
        <polygon key={i} points={poly} fill="none" stroke="rgba(10,10,10,0.12)" strokeWidth="1" />
      ))}
      {STRUCT_KEYS.map((_, i) => {
        const angle = (Math.PI * 2 * i) / n - Math.PI / 2;
        const x2 = cx + Math.cos(angle) * r;
        const y2 = cy + Math.sin(angle) * r;
        return <line key={i} x1={cx} y1={cy} x2={x2} y2={y2} stroke="rgba(10,10,10,0.12)" strokeWidth="1" />;
      })}
      <polygon points={points} fill="rgba(255,90,0,0.25)" stroke="var(--accent)" strokeWidth="2" />
    </svg>
  );
}